import { firebaseRecursosRepository } from '../../infrastructure/recursos/firebaseRecurso.repository'

export const get = async id => {
  const recurso = await firebaseRecursosRepository.obtenerRecurso(id)
  if (recurso.exists) {
    return {
      id: recurso.id,
      nombre: recurso.data().Nombre,
      destinatario: recurso.data().Destinatario,
      descripcion: recurso.data().Descripcion,
      link: recurso.data().Link,
      etiquetas: recurso.data().Etiquetas,
      imagenUrl: recurso.data().ImagenUrl,
    }
  }
  return undefined
}
